import { render, staticRenderFns } from "./Receipt-products.vue?vue&type=template&id=5f081d0e"
import script from "./Receipt-products.vue?vue&type=script&lang=js"
export * from "./Receipt-products.vue?vue&type=script&lang=js"
import style0 from "./Receipt-products.vue?vue&type=style&index=0&id=5f081d0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports